module.exports = __webpack_public_path__ + "img/default_form.d01f728f.svg";